import { render, staticRenderFns } from "./PDFViewDlg.vue?vue&type=template&id=c6075a8a"
import script from "./PDFViewDlg.vue?vue&type=script&lang=js"
export * from "./PDFViewDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports